import { createApi } from '@reduxjs/toolkit/query/react';
import { addQueryContext, WithQueryContext } from 'core/apiQueryContext';
import { hasApiAccessToken } from 'core/apiConfig';
import { gatewayApiQuery } from 'core/rtkQuery';

/**
 * Stock of a single article in the automated storage, as reported by AOL.
 *
 * Not part of the slm-backend spec: served by the auth gateway (`/automationStock`).
 */
export type ArticleAutomationStockDto = {
  id: string;
  pickingSolution: string;
  availableQuantity: number;
  allocatedQuantity: number;
  blockedQuantity: number;
  totalStockQuantity: number;
};

export type AutomationStockDto = {
  articles: ArticleAutomationStockDto[];
};

const automationStockApiDef = createApi({
  reducerPath: 'automationStockApi',
  baseQuery: gatewayApiQuery(),

  endpoints: build => ({
    getAutomationStock: build.query<
      AutomationStockDto,
      WithQueryContext<{ itemNo: string }>
    >({
      query: ({ buCode, itemNo }) => ({
        url:
          buCode && itemNo && hasApiAccessToken() ? '/automationStock' : null,
        params: {
          articleId: itemNo,
          buCode,
        },
      }),
    }),
  }),
});

const automationStockApi = addQueryContext(automationStockApiDef);
export const { useGetAutomationStockQuery } = automationStockApi;

export default automationStockApi;
